// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_10uei","smallLinkTypography":"nSRhi","titleTypography":"_2dOxw","cardTitleTypography":"_2kLTg","nameCell":"_2oJ_A","truncate":"KNgZc","base":"_3dD6P","noPartnerPlans":"_24XuE","buttonContainer":"-a0JS","searchinput":"_3sBz7"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerReports/PartnerPlan/components/PartnerPlanList.scss
// module id = 2534
// module chunks = 0